<script>
export default {
  props: {
    color: {
      type: String,
      default: "#000",
    },
  },
};
</script>

<template>
  <svg
    aria-label="Pfleger-Symbol"
    width="24"
    height="27"
    viewBox="0 0 24 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.24911 26.1579H16.7509H18.9787C21.1996 26.1579 23 26.1579 23 26.1579V12.0754C22.9881 11.2104 22.5 10.5 21.8861 9.86983L14.2668 1.79351C12.932 0.735498 11.0346 0.735498 9.69975 1.79351L2.11392 9.88085C1.5 10.5 1.00855 11.2207 1 12.0864V26.1579C1 26.1579 2.80038 26.1579 5.02127 26.1579H7.24911Z"
      stroke="#130F26"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.48387 11V14.4839H6V19.5161H9.48387V23H14.5161V19.5161H18V14.4839H14.5161V11H9.48387ZM16.4516 16.0323V17.9677H12.9677V21.4516H11.0323V17.9677H7.54839V16.0323H11.0323V12.5484H12.9677V16.0323H16.4516Z"
      fill="black"
    />
  </svg>
</template>
